module.exports = __webpack_public_path__ + "img/safty_4.d34ca08d.png";